<template>
  <div v-if="plate">
    <v-checkbox
      v-model="plate.isParamsAsked"
      label="Let's confirm your basic info:"
      :error="$v.plate.isParamsAsked.$error"
    />

    <div class="d-flex justify-center">
      <div>
        <PlateFieldForm
          name="Name"
          :value="currentLead.fullname"
          @update="currentLead.fullname = $event"
        />

        <PlateDatepickerForm
          name="Date of Birth"
          :value="format(new Date(currentLead.birth_date), 'MM-dd-yyyy')"
          @update="currentLead.birth_date = $event"
        />

        <PlateHeightForm
          name="Height"
          :value="currentLead.height"
          @update="currentLead.height = $event"
        />

        <PlateFieldForm
          name="Weight"
          :value="currentLead.weight"
          @update="currentLead.weight = $event"
        />
      </div>
    </div>

    <p class="mt-4">Are you US citizen?</p>

    <!--  Todo new backend field usCitizen  -->

    <v-radio-group
      class="radio-questions"
      column
      v-model="currentLead.usCitizen"
    >
      <v-radio :value="true" label="Yes" />
      <v-radio :value="false" label="No" />
    </v-radio-group>

    <p class="mt-4">
      Do you engage in any dangerous activities like: Skydive, hang-glide, hot
      air balloon, race, scuba dive:
    </p>

    <!--  Todo new backend field  dangerousActivity -->

    <v-radio-group
      class="radio-questions"
      column
      v-model="currentLead.dangerousActivity"
    >
      <v-radio :value="true" label="Yes" />
      <v-radio :value="false" label="No" />
    </v-radio-group>

    <p class="mt-4">
      Have you used any form of tobacco or nicotine product in the last 5 years?
    </p>

    <v-radio-group class="radio-questions" column v-model="currentLead.tobacco">
      <v-radio :value="1" label="Yes" />
      <v-radio :value="0" label="No" />
    </v-radio-group>

    <p class="mt-4">
      In the past 30 days have you been diagnosed, treated or tested positive
      for COVID 19?
    </p>

    <!--  Todo new backend field  vaccinated -->

    <v-radio-group
      class="radio-questions"
      column
      v-model="currentLead.vaccinated"
    >
      <v-radio :value="true" label="Yes" />
      <v-radio :value="false" label="No" />
    </v-radio-group>

    <p class="mt-4">Is approximate annual incoming?</p>

    <div class="d-flex justify-center">
      <v-text-field
        v-mask="'$##################'"
        v-model="currentLead.total_income"
        label="Income per year"
        style="max-width: 250px"
      />
    </div>

    <PlateFooter
      :onBack="onBack"
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import { PlatesSteps } from '@/common/variables';
import PlateFieldForm from '@/components/lead/plates/fields/PlateFieldForm';
import PlateHeightForm from '@/components/lead/plates/fields/PlateHeightForm';
import PlateDatepickerForm from '@/components/lead/plates/fields/PlateDatepickerForm';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { isChecked } from '@/common/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'BasicInfoPlate',
  components: {
    PlateDatepickerForm,
    PlateFieldForm,
    PlateHeightForm,
    PlateFooter,
  },
  computed: {
    ...mapGetters({ states: 'baseData/states' }),
  },
  props: {
    lead: Object,
  },
  data: () => ({
    plate: null,
    isLoading: false,
    currentLead: {},
  }),
  mounted() {
    this.currentLead = { ...this.lead };
    this.currentLead.usCitizen = !!this.lead.city;

    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.basicInfo
    );
    this.plate = data;
  },
  methods: {
    format,
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.process);
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit(
        'lead/SET_LEAD',
        Object.assign(this.lead, this.currentLead)
      );

      this.$store.commit('plates/setStep', PlatesSteps.health);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
  },
  validations: {
    plate: {
      isParamsAsked: {
        checked: isChecked,
      },
    },
  },
};
</script>

<style></style>
